"use strict";

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var react_1 = require("react");

var uniqid_1 = __importDefault(require("uniqid"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Icon_1 = require("../../atoms/Icon");

var Stateful_1 = require("../InputSelect/Stateful");

var InputTextfield_1 = require("../InputTextfield");

var _SelectWidget_1 = require("./_SelectWidget");
/**
 * InputSelect
 * @description
 * https://material.io/develop/web/components/input-controls/select-menus/
 * https://jira.intranet.commerzbank.com/browse/LSG-135
 * https://confluence.neugelb.com/display/BR/Drop+Down
 */


var InputSelect =
/** @class */
function (_super) {
  __extends(InputSelect, _super);

  function InputSelect(props) {
    var _this = _super.call(this, props) || this;

    _this.textInputRef = react_1.createRef();
    _this.isIE11 = typeof window !== "undefined" && !!window.MSInputMethodContext && !!document.documentMode;

    _this.onInputClick = function () {
      _this.setState(function (prevState) {
        return {
          widgetOpen: !prevState.widgetOpen,
          openAbove: _this.shouldWidgetOpenAbove()
        };
      });
    };

    _this.onEscape = function (doFocus) {
      _this.setState({
        widgetOpen: false
      });

      if (doFocus) {
        _this.textInputRef.current.focus();
      }
    };

    _this.onChange = function (value, _name, e) {
      _this.props.onChange(value, _this.props.name, e);

      _this.textInputRef.current.focus();
    };

    _this.onInputChange = function (value, _name, e) {
      if (value === "") {
        // The event this.props.onchange is already fired in the select widget, so don't fire it twice
        _this.props.onChange(value, _this.props.name, e);
      }

      _this.textInputRef.current.focus();
    };

    _this.onKeyDown = function (key) {
      switch (key) {
        case "Enter":
        case "Down": // IE specific value

        case "ArrowDown":
          _this.setState({
            widgetOpen: true,
            openAbove: _this.shouldWidgetOpenAbove()
          });

          break;

        default:
          break;
      }
    };

    _this.handleFocusLost = function (ev) {
      if (utils_1.DomUtils.isTargetInsideContainer(ev.relatedTarget, document.getElementById(_this.uuid))) {
        // is there a relatedTarget (element which is focused next) or is the relatedTarget within this component
        ev.preventDefault();
      } else {
        _this.setState({
          widgetOpen: false
        });

        if (_this.props.onBlur) {
          _this.props.onBlur(name, ev);
        }
      }
    };

    _this.handleFocusLostBlur = function (e) {
      // We need the "related" target -> this is the element which gets the focus next.
      // With IE11, the onBlur event does not support the relatedTarget (it's null in IE)
      if (!_this.isIE11) {
        _this.handleFocusLost(e);
      }
    };

    _this.handleFocusLostFocusout = function (e) {
      // We need the "related" target -> this is the element which gets the focus next.
      // With IE11, the onBlur event does not support the relatedTarget (it's null in IE)
      // Only the onfocusout event contains the relatedTarget.
      // Unfortunately, you cannot use a React onfocusout event (because it does not exist).
      if (_this.isIE11) {
        _this.handleFocusLost(e);
      }
    };

    _this.uuid = props.id || uniqid_1["default"]("lsg--input-select-");
    _this.state = {
      widgetOpen: false
    };
    return _this;
  }

  InputSelect.prototype.componentWillReceiveProps = function (nextProps) {
    if (this.props.value !== nextProps.value) {
      this.setState({
        widgetOpen: false
      });
    }
  };

  InputSelect.prototype.componentDidMount = function () {
    this.textInputRef.current.addEventListener("blur", this.handleFocusLostBlur);
    this.textInputRef.current.addEventListener("focusout", this.handleFocusLostFocusout);
  };

  InputSelect.prototype.componentWillUnmount = function () {
    this.textInputRef.current.removeEventListener("blur", this.handleFocusLostBlur);
    this.textInputRef.current.removeEventListener("focusout", this.handleFocusLostFocusout);
  };

  InputSelect.prototype.render = function () {
    var _a = this.props,
        value = _a.value,
        options = _a.options,
        name = _a.name;
    var _b = this.state,
        widgetOpen = _b.widgetOpen,
        openAbove = _b.openAbove; // TODO performance

    var option = options.find(function (o) {
      return o.value === value;
    });
    var stringValue = option ? option.label : "";
    var iconText = widgetOpen ? utils_1.Localization.texts.lsg.component.InputSelect.close : utils_1.Localization.texts.lsg.component.InputSelect.close;
    var idInput = this.uuid + "_input";
    return React.createElement("div", {
      id: this.uuid,

      /*onClick={(event) => this.onClick(event)}*/
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "inputselect", widgetOpen && CSSPrefix_1.lsgPre + "inputselect__widget-open"])
    }, React.createElement(InputTextfield_1.InputTextfield, __assign({}, this.props, {
      className: CSSPrefix_1.lsgPre + "inputselect-input",
      id: idInput,
      value: stringValue,
      clearIcon: this.props.clearIcon,
      iconName: Icon_1.Icon.Names.interaction_arrows_chevronDown,
      iconText: iconText,
      onChange: this.onInputChange,
      onBlur: undefined,
      hasWidget: true,
      manualFocus: widgetOpen,
      onClick: this.onInputClick,
      onKeyDown: this.onKeyDown,
      onIconClick: this.onInputClick,
      htmlAttrs: {
        tabIndex: 0
      },
      inputRef: this.textInputRef
    })), widgetOpen && React.createElement(_SelectWidget_1.SelectWidget, {
      onBlur: this.props.onBlur,
      onChange: this.onChange,
      onEscape: this.onEscape,
      value: value,
      options: options,
      name: name,
      idInput: idInput,
      openAbove: openAbove
    }));
  };

  InputSelect.prototype.shouldWidgetOpenAbove = function () {
    if (!this.textInputRef.current) {
      return false;
    }

    return utils_1.WindowEvents.shouldWidgetOpenAbove(this.textInputRef.current);
  };

  InputSelect.defaultProps = {
    options: [],
    onChange: function onChange() {
      /* empty */
    },
    clearIcon: true
  };
  InputSelect.Stateful = Stateful_1.Stateful;
  return InputSelect;
}(React.Component);

exports.InputSelect = InputSelect;